import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Translate from "../../Components/Multilanguage/Translate";

const GiftFail = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const message = location.state?.message;

  const handleTryAgain = () => {
    navigate("/gift/purchase");
  };

  const handleGoHome = () => {
    navigate("/");
  };

  return (
    <div className="giftFail">
      <div className="failContainer">
        <div className="errorIcon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="92"
            fill="#dc3545"
            viewBox="0 0 16 16"
          >
            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM5.354 4.646a.5.5 0 1 0-.708.708L7.293 8l-2.647 2.646a.5.5 0 0 0 .708.708L8 8.707l2.646 2.647a.5.5 0 0 0 .708-.708L8.707 8l2.647-2.646a.5.5 0 0 0-.708-.708L8 7.293 5.354 4.646z" />
          </svg>
        </div>
        <h2>
          <Translate textKey="gift_purchase_failed" />
        </h2>
        {/* <p className="errorMessage">
          {message}
        </p> */}
        <div className="actionButtons">
          <button className="tryAgainBtn" onClick={handleTryAgain}>
            <Translate textKey="try_again" />
          </button>
          <button className="homeBtn" onClick={handleGoHome}>
            <Translate textKey="go_to_home" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default GiftFail;
